module.exports = __webpack_public_path__ + "3c45197adab3b3c8aabb698e2ef5740c.MP3";